import { getCookie, setCookie } from "@/shared";
import { COOKIE_KEYS } from "../constants";
import { alias, get_property, identify } from "./mixpanel-actions.utils";

export const handleMixpanelAuth = (identifier: string) => {
  const currentDistinctId = get_property("distinct_id");
  const cookieDistinctId = getCookie(COOKIE_KEYS.DISTINCT_ID_COOKIE_KEY);

  if (cookieDistinctId && cookieDistinctId !== identifier) {
    alias(identifier, cookieDistinctId);
  }

  if (currentDistinctId !== identifier) {
    identify(identifier);
  }

  setCookie({
    name: COOKIE_KEYS.DISTINCT_ID_COOKIE_KEY,
    value: identifier,
    days: 365,
  });
};
